export const CHECK_EMAIL_AVAILABLE = 'CHECK_EMAIL_AVAILABLE';
export const CHECK_EMAIL_AVAILABLE_ERROR = 'CHECK_EMAIL_AVAILABLE_ERROR';

export const CREATE_NEW_TPO_USER_SUCCESS = 'CREATE_NEW_TPO_USER_SUCCESS';
export const CREATE_NEW_TPO_USER_ERROR = 'CREATE_NEW_TPO_USER_ERROR';
export const CREATE_NEW_LEARNER_SUCCESS = 'CREATE_NEW_LEARNER_SUCCESS';
export const CREATE_NEW_LEARNER_ERROR = 'CREATE_NEW_LEARNER_ERROR';
export const SEND_VERIFICATION_EMAIL_SUCCESS = 'SEND_VERIFICATION_EMAIL_SUCCESS';
export const SEND_VERIFICATION_EMAIL_ERROR = 'SEND_VERIFICATION_EMAIL_ERROR';
export const PROCESS_VERIFICATION_CODE_SUCCESS = 'PROCESS_VERIFICATION_CODE_SUCCESS';
export const PROCESS_VERIFICATION_CODE_ERROR = 'PROCESS_VERIFICATION_CODE_ERROR';
export const AUTHENTICATE_USER_SUCCESS = 'AUTHENTICATE_USER_SUCCESS';
export const AUTHENTICATE_USER_ERROR = 'AUTHENTICATE_USER_ERROR';
export const DEAUTHENTICATE_USER = 'DEAUTHENTICATE_USER';
export const CREATE_NEW_MEMBER_SUCCESS = 'CREATE_NEW_MEMBER_SUCCESS';
export const CREATE_NEW_MEMBER_ERROR = 'CREATE_NEW_MEMBER_ERROR';
export const CREATE_NEW_MEMBER_ADMIN_SUCCESS = 'CREATE_NEW_MEMBER_ADMIN_SUCCESS';
export const CREATE_NEW_MEMBER_ADMIN_ERROR = 'CREATE_NEW_MEMBER_ADMIN_ERROR';

export const PARCHMENT_IDENTITY_PROVIDER_KEY = 'parchment-identity-provider';
export const MEMBER_SERVICE_API_KEY = 'member-service-api';
export const ADDRESS_VERIFICATION_API_KEY = 'address-verification-api';
